import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedMaterialModule } from '../shared-material.module';
import { MariaChatDialogComponent } from './dialog/maria-chat-dialog/maria-chat-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import {
  MariaChatRatingBadDialogComponent
} from './dialog/maria-chat-rating-bad-dialog/maria-chat-rating-bad-dialog.component';

import { SharedDirectivesModule } from '../directives/shared.directives.module';

// ONLY FOR DEMO
// ALWAYS REQUIRED

const components = [
  MariaChatRatingBadDialogComponent,
  MariaChatDialogComponent,
];

@NgModule({
  imports: [
    SharedPipesModule,
    CommonModule,
    RouterModule,
    SharedMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    SharedDirectivesModule,
  ],
  declarations: components,
  exports: components
})
export class MariaModule {
}
